import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import CustomPopUp from '@/components/common/CustomPopUp';
import InventoryPlotPopupContent from '@/components/ForestMassDetail/InventoryPlotPopupContent';
import type {Species} from '@/domain/entities/Species';
import type {InventoryPlotMapFeature} from '@/domain/utils/getGeoJsonFromInventoryPlots';

//TYPES
type Props = {
  species: Array<Species>;
  inventoryPlotMapFeature: InventoryPlotMapFeature;
  onClick: (uuid: string) => void;
  onClose: () => void;
};

const InventoryPlotPopup: FC<Props> = ({species, inventoryPlotMapFeature, onClick}) => {
  const {t} = useTranslation();
  const {properties, geometry} = inventoryPlotMapFeature;

  return (
    <CustomPopUp
      key={properties.uuid}
      longitude={Number(geometry.coordinates[0])}
      latitude={Number(geometry.coordinates[1])}
      title={t('inventoryPlots.title')}
    >
      <InventoryPlotPopupContent species={species} inventoryPlotMapFeatureProps={properties} onClick={onClick} />
    </CustomPopUp>
  );
};
export default InventoryPlotPopup;
